import React from 'react';
import PropTypes from 'prop-types';
import { AddToTrolley, Button, Alert as BoltAlert, CheckboxItem } from '@sainsburys-tech/bolt';
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider';
import * as Styled from './ProductCareFooter.styles';
var monthlySynapticaID = '690247';
var monthlyIpidLink = "//documents.4rgos.it/v1/static/".concat(monthlySynapticaID, "_IPID");

var Link = function Link(_ref) {
  var synapticaId = _ref.synapticaId,
      text = _ref.text,
      type = _ref.type,
      dataTest = _ref.dataTest,
      url = _ref.url;
  var href = url || "//documents.4rgos.it/v1/static/".concat(synapticaId, "_").concat(type);
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noreferrer",
    "data-test": dataTest
  }, text);
};

var TermsAndCondition = function TermsAndCondition(_ref2) {
  var synapticaId = _ref2.synapticaId,
      dataTest = _ref2.dataTest,
      ipidLink = _ref2.ipidLink,
      leafletCopy = _ref2.leafletCopy,
      leafletLink = _ref2.leafletLink;
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "I have read the", ' ', /*#__PURE__*/React.createElement(Link, {
    url: ipidLink,
    synapticaId: synapticaId,
    text: 'Insurance Product Information Document (IPID)',
    type: 'IPID',
    dataTest: "".concat(dataTest, "-IPID")
  }), ' ', "and the", ' ', /*#__PURE__*/React.createElement(Link, {
    url: leafletLink,
    synapticaId: synapticaId,
    text: leafletCopy,
    type: 'leaflet',
    dataTest: "".concat(dataTest, "-terms")
  }), ", which include details of the complaints procedure."));
};

var ProductCareFooter = function ProductCareFooter(_ref3) {
  var synapticaId = _ref3.synapticaId,
      addToTrolley = _ref3.addToTrolley,
      partNumbers = _ref3.partNumbers,
      hasAgreeTerms = _ref3.hasAgreeTerms,
      setHasAgreeTerms = _ref3.setHasAgreeTerms,
      overwriteAddToTrolley = _ref3.overwriteAddToTrolley,
      isMonthly = _ref3.isMonthly,
      overwriteCTAText = _ref3.overwriteCTAText,
      dataTest = _ref3['data-test'],
      ipidLink = _ref3.ipidLink,
      leafletCopy = _ref3.leafletCopy,
      leafletLink = _ref3.leafletLink;
  var addToTrolleyButtonOptions = {
    partNumber: partNumbers,
    full: true,
    isEnabled: hasAgreeTerms,
    openView: true,
    disableWarranties: true,
    onClick: addToTrolley,
    name: '',
    'data-test': "".concat(dataTest, "-add-to-trolley")
  };

  var _useVocab = useVocab(),
      ADD_TO_TROLLEY = _useVocab.ADD_TO_TROLLEY;

  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(Styled.PolicyLink, {
    kind: "link",
    href: "".concat(isMonthly && !ipidLink && !synapticaId ? monthlyIpidLink : '/help/argos-care/'),
    target: "_blank",
    "data-test": "".concat(dataTest, "-policy-link")
  }, isMonthly ? 'Insurance Product Information Document (IPID)' : 'Find out more about Argos Care'), isMonthly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BoltAlert, {
    kind: "info",
    isCloseable: false
  }, "To add monthly care, buy your item first and add after your order is confirmed."), /*#__PURE__*/React.createElement(Button, {
    kind: "primary",
    full: true,
    onClick: addToTrolley,
    "data-test": "".concat(dataTest, "-back")
  }, overwriteCTAText || 'Back to product details')), !isMonthly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.CheckboxContainer, {
    "data-test": "".concat(dataTest, "-agree-checkbox")
  }, /*#__PURE__*/React.createElement(CheckboxItem, {
    hasBackground: false,
    name: "policy-accept-footer",
    id: "policy-accept-footer",
    onChange: function onChange() {
      return setHasAgreeTerms(!hasAgreeTerms);
    },
    checked: hasAgreeTerms,
    label: /*#__PURE__*/React.createElement(TermsAndCondition, {
      synapticaId: synapticaId,
      dataTest: dataTest,
      ipidLink: ipidLink,
      leafletCopy: leafletCopy,
      leafletLink: leafletLink
    })
  })), overwriteAddToTrolley ? /*#__PURE__*/React.createElement(Button, {
    kind: "primary",
    full: true,
    disabled: !hasAgreeTerms,
    onClick: addToTrolley,
    "data-test": "".concat(dataTest, "-add")
  }, ADD_TO_TROLLEY) : /*#__PURE__*/React.createElement(AddToTrolley.Button, addToTrolleyButtonOptions)));
};

ProductCareFooter.propTypes = {
  /**
   * Warranty id [DEPRECATED] use the links provided by product-care service
   */
  synapticaId: PropTypes.string,

  /**
   * Warranty IPID link
   */
  ipidLink: PropTypes.string,

  /**
   * Warranty Leaflet Copy
   */
  leafletCopy: PropTypes.string,

  /**
   * Warranty Leaflet link
   */
  leafletLink: PropTypes.string,

  /**
   * Add to Trolley on click function
   */
  addToTrolley: PropTypes.func,

  /**
   * Part Number to add to trolley
   */
  partNumbers: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]).isRequired,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string
};
ProductCareFooter.defaultProps = {
  'data-test': 'product-care-footer'
};
export default ProductCareFooter;